import Comment from "work/proposals/comments/comment";

/**
 * The comment an author has aimed at a different audience: the same comment, on the thread that
 * audience owns.
 *
 * Widening drops the thread id, and that is what re-homes the comment — the server then
 * get-or-creates the counterparty-facing Forum rather than reusing the internal one it came from.
 * Narrowing keeps the id, so a comment pulled back stays on the thread it is already on.
 *
 * A comment and its thread are immutable, and one `CommentThread` instance is routinely shared by
 * every comment in a conversation, so this returns a new comment rather than writing the new audience
 * into the thread it was handed. The re-aim takes effect wherever the caller puts the result: for an
 * open editor that is the row's own draft, and from there it reaches the store — and the audience the
 * page Save reads off it — only when the author saves.
 *
 * Widening is one-way. What the counterparty has already read cannot be taken back inside the author's
 * party, which is why the comment's audience switch disables itself once the comment is external. This
 * function states what re-aiming *is*; who may do it is that switch's to say.
 */
export default function reaimCommentAtAudience(comment: Comment, isExternal: boolean): Comment {
  if (comment.thread.isExternal === isExternal) return comment;

  return comment.with({
    thread: isExternal ? comment.thread.with({ isExternal, id: undefined }) : comment.thread.with({ isExternal }),
  });
}
